<template>
	<main class="h-screen overflow-y-auto bg-white p-4">
		<PostQuiz
			:jsonData="emptyQuizData"
			:overrideURL="sourceUrl"
			:selectedLanguage="selectedLanguage"
			@close="closeFrame"
		/>
	</main>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import PostQuiz from '@/components/PostQuiz.vue'
import type { LanguageCodes, QuizQuestionsItem } from '@/types'

type PostQuizFrameData = {
	postQuiz: {
		questions: QuizQuestionsItem[]
	}
	_links: {
		postQuiz: {
			href: string
		}
		postQuizEdit: {
			href: string
		}
	}
}

const props = defineProps<{
	sourceUrl?: string | string[]
	lng?: string | string[]
}>()

const sourceUrl = computed(() => {
	const value = Array.isArray(props.sourceUrl) ? props.sourceUrl[0] : props.sourceUrl
	return String(value ?? '').trim()
})

const selectedLanguage = computed(() => {
	const value = Array.isArray(props.lng) ? props.lng[0] : props.lng
	return String(value || 'de') as LanguageCodes
})

const emptyQuizData = computed<PostQuizFrameData>(() => ({
	postQuiz: {
		questions: []
	},
	_links: {
		postQuiz: {
			href: sourceUrl.value
		},
		postQuizEdit: {
			href: sourceUrl.value
		}
	}
}))

const closeFrame = () => {
	window.parent?.postMessage({ action: 'close-and-refresh' }, '*')
}
</script>
